var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form-layout',[_c('template',{slot:"maintenance"},[_c('Maintenance')],1),_c('template',{slot:"heading"},[_c('h5',[_vm._v("Bloom Client Version 2")]),_c('h5',[_vm._v("Bloomキャリア登録　企業管理画面")])]),_c('login-form')],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }